import { render, staticRenderFns } from "./KpiFolderSubPopup.vue?vue&type=template&id=2f689618&scoped=true&"
import script from "./KpiFolderSubPopup.vue?vue&type=script&lang=ts&"
export * from "./KpiFolderSubPopup.vue?vue&type=script&lang=ts&"
import style0 from "./KpiFolderSubPopup.vue?vue&type=style&index=0&id=2f689618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f689618",
  null
  
)

export default component.exports